import React, { useEffect, useState } from 'react'
import AffiliateEarnings from './affiliate_earnings'
import Insights from './insights'
import UploadedFiles from './uploaded_files'
import { useAuth } from '../../../providers/auth_provider'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import EditUser from './edit_user'
import { Helmet } from 'react-helmet'
export default function ViewUser() {
    const [tab, setTab] = useState('account');
    const [userData, setUserData] = useState(null);
    const { token } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const user_id = location?.state?.user_id;

    const fetchUserData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/${user_id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            })
            if (response.status === 200) {
                setUserData(response.data)
            }
        }
        catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        if (!user_id) {
            navigate('/users/view');
        } else {
            fetchUserData();
        }
    }, [user_id]);


    return (
        <>
            <Helmet>
                <title>{userData?.first_name + ' ' + userData?.last_name} - User Profile</title>
            </Helmet>
            <div className="row gy-6 gy-md-0">
                {/* User Sidebar */}
                <div className="col-xl-3 col-lg-5 col-md-5 order-1 order-md-0">
                    {/* User Card */}
                    <div className="card mb-6">
                        <div className="card-body pt-12">
                            <div className="user-avatar-section">
                                <div className=" d-flex align-items-center flex-column">
                                    <img
                                        className="img-fluid rounded-3 mb-4"
                                        src="/assets/img/avatars/1.png"
                                        height={120}
                                        width={120}
                                        alt="User avatar" />
                                    <div className="user-info text-center">
                                        <h5>{userData?.first_name + ' ' + userData?.last_name}</h5>
                                        <span className="badge bg-label-primary rounded-pill">
                                            {/* {userData?.role.name} */}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="d-flex justify-content-around flex-wrap my-6 gap-0 gap-md-3 gap-lg-4">
                                <div className="d-flex align-items-center me-5 gap-4">
                                    <div className="avatar">
                                        <div className="avatar-initial bg-label-primary rounded-3">
                                            <i className="ri-check-line ri-24px" />
                                        </div>
                                    </div>
                                    <div>
                                        <h5 className="mb-0">1.23k</h5>
                                        <span>Files</span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center gap-4">
                                    <div className="avatar">
                                        <div className="avatar-initial bg-label-primary rounded-3">
                                            <i className="ri-briefcase-line ri-24px" />
                                        </div>
                                    </div>
                                    <div>
                                        <h5 className="mb-0">568</h5>
                                        <span>Insights</span>
                                    </div>
                                </div>
                            </div> */}
                            <h5 className="pb-4 border-bottom mb-4">Details</h5>
                            <div className="info-container">
                                <ul className="list-unstyled mb-6">
                                    <li className="mb-2">
                                        <span className="fw-medium text-heading me-2">Email:</span>
                                        <span>{userData?.email}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="fw-medium text-heading me-2">Status:</span>
                                        <span className={`text-capitalize badge rounded-pill ${userData?.status === 'active' ? 'bg-label-success' : userData?.status === 'inactive' ? 'bg-label-warning' : 'bg-label-danger'}`}>
                                            {userData?.status}
                                        </span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="fw-medium text-heading me-2">Contact:</span>
                                        <span>{userData?.phone_no}</span>
                                    </li>
                                </ul>
                                <div className="d-flex justify-content-center">

                                    <a
                                        href="javascript:;"
                                        className="btn btn-primary me-4"
                                        data-bs-target="#editUser"
                                        data-bs-toggle="modal"
                                    >
                                        Edit
                                    </a>

                                    {/* <a
                                        href="javascript:;"
                                        className="btn btn-outline-danger suspend-user"
                                    >
                                        Suspend
                                    </a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /User Card */}
                </div>
                {/*/ User Sidebar */}
                {/* User Content */}
                <div className="col-xl-9 col-lg-7 col-md-7 order-0 order-md-1">
                    {/* User Tabs */}
                    {/* <div className="nav-align-top">
                        <ul className="nav nav-pills flex-column flex-md-row mb-6 row-gap-2">
                            {
                                adminData?.role?.permissions?.users?.user_overview &&
                                <li className="nav-item">
                                    <button className={`nav-link ${tab === 'account' ? 'active' : ''}`} onClick={() => setTab('account')}>
                                        <i className="ri-group-line me-2" />
                                        Account
                                    </button>
                                </li>
                            }
                            {adminData?.role?.permissions?.users?.user_insights &&
                                <li className="nav-item">
                                    <button className={`nav-link ${tab === 'insights' ? 'active' : ''}`} onClick={() => setTab('insights')}>
                                        <i className="ri-lock-2-line me-2" />
                                        Insights
                                    </button>
                                </li>
                            }
                            {adminData?.role?.permissions?.users?.user_files &&
                                <li className="nav-item">
                                    <button className={`nav-link ${tab === 'files' ? 'active' : ''}`} onClick={() => setTab('files')}>
                                        <i className="ri-bookmark-line me-2" />
                                        Files
                                    </button>
                                </li>
                            }
                        </ul>
                    </div> */}
                    {tab === 'account' && <AffiliateEarnings user_id={user_id} />}
                    {tab === 'insights' && <Insights />}
                    {tab === 'files' && <UploadedFiles user_id={user_id} />}
                </div>
                {/*/ User Content */}
            </div>
            {/* Modal */}
            {/* Edit User Modal */}
            <EditUser fetchUserData={fetchUserData} userData={userData} />
            {/*/ Edit User Modal */}
            {/* /Modal */}
        </>
    )
}
